import React from 'react';
import {Search,X,AlertTriangle} from 'lucide-react';

export const Modal=({open,onClose,title,children,width=520})=>{
  if(!open)return null;
  return(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{maxWidth:width}} onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}><X size={18}/></button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const SearchBar=({value,onChange,placeholder='Search...'})=>(
  <div className="search-bar">
    <Search size={15}/>
    <input className="form-input" value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={{paddingLeft:36}}/>
  </div>
);

export const FormInput=({label,value,onChange,type='text',placeholder,options,disabled,required,className=''})=>(
  <div className={`form-group ${className}`}>
    {label&&<label className="form-label">{label}{required&&<span style={{color:'var(--danger)'}}> *</span>}</label>}
    {options
      ?<select className="form-select" value={value} onChange={e=>onChange(e.target.value)} disabled={disabled}>
        {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      :type==='textarea'
        ?<textarea className="form-textarea" value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} disabled={disabled}/>
        :<input className="form-input" type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} disabled={disabled}/>}
  </div>
);

export const Badge=({children,variant='primary'})=><span className={`badge badge-${variant}`}>{children}</span>;

// DataTable accepts optional loadingText / emptyText for i18n
export const DataTable=({columns,data=[],actions,loading,loadingText='Loading...',emptyText='No records'})=>(
  <div className="table-wrapper">
    <table className="data-table">
      <thead>
        <tr>
          {columns.map(c=><th key={c.key}>{c.label}</th>)}
          {actions&&<th style={{textAlign:'right'}}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {loading
          ?<tr><td colSpan={columns.length+(actions?1:0)} className="empty-state">{loadingText}</td></tr>
          :data.length===0
            ?<tr><td colSpan={columns.length+(actions?1:0)} className="empty-state">{emptyText}</td></tr>
            :data.map((r,i)=>(
              <tr key={r.id||i}>
                {columns.map(c=><td key={c.key}>{c.render?c.render(r):r[c.key]}</td>)}
                {actions&&<td style={{textAlign:'right',whiteSpace:'nowrap'}}>{actions(r)}</td>}
              </tr>
            ))}
      </tbody>
    </table>
  </div>
);

export const PageHeader=({title,subtitle,action})=>(
  <div className="page-header">
    <div><h2>{title}</h2>{subtitle&&<p>{subtitle}</p>}</div>
    {action}
  </div>
);

export const StatCard=({label,value,sub,icon:Icon,color='var(--primary)'})=>(
  <div className="card stat-card">
    <div className="stat-icon" style={{background:color+'18'}}><Icon size={20} color={color}/></div>
    <div>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub&&<div className="stat-sub">{sub}</div>}
    </div>
  </div>
);

export const FilterButtons=({options,active,onChange})=>(
  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
    {options.map(o=><button key={o} className={`filter-btn ${active===o?'active':''}`} onClick={()=>onChange(o)}>{o}</button>)}
  </div>
);

// NoAccess accepts optional translated props
export const NoAccess=({title='Access Denied',message='Contact your administrator.'})=>(
  <div className="no-access">
    <div className="no-access-icon"><AlertTriangle size={24} color="var(--danger)"/></div>
    <h3 style={{marginBottom:8}}>{title}</h3>
    <p className="text-muted" style={{fontSize:13}}>{message}</p>
  </div>
);

export const fmt=n=>'$'+Number(n||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
export const fmtDate=d=>d?new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'}):'—';
